// import statements remain the same
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const WorkWithTcsComponent = () => {
  return (
    <div className="bg-[#f9f9f9] pt-[2rem] pb-[40px] sm:pt-[6.2rem] sm:pb-[6.2rem] sm:mx-[auto]">
      <div className="flex flex-col items-center text-[#373737]">
        <h1 className="font-bold sm:text-4xl text-3xl max-w-[23rem]">
          Working With TCS
        </h1>
        <hr className="hr" />
      </div>

      <div className="mx-[1.5rem] lg:mx-[3rem] md:mx-[.5rem] sm:mx-[3rem] main-working md:flex sm:grid grid md:gap-2 gap-4 lg:pl-[2rem] lg:pr-[2rem] justify-center mt-[2rem]">
        <div
          className="working-image bottom-[2rem] mt-[1rem] flex flex-col items-start p-4 h-[15rem] 2xl:h-[15rem] bg-center bg-no-repeat bg-cover rounded-md w-full transition-all duration-300 hover:shadow-lg hover:scale-[1.02] hover:brightness-110"
          style={{ backgroundImage: "url('/Home/training.jpg')" }}
        >
          <a
            href="/trainingdevelopment"
            className="flex w-[100%] h-[100%] p-[1rem] items-end"
          >
            <h2 className="lg:text-2xl text-[19px] font-bold text-white transition-colors duration-300 hover:text-gray-100">
              Training and Development
            </h2>
          </a>
        </div>
        <div
          className="working-image bottom-[2rem] mt-[1rem] flex flex-col items-start p-4 h-[15rem] 2xl:h-[15rem] bg-center bg-no-repeat bg-cover rounded-md w-full transition-all duration-300 hover:shadow-lg hover:scale-[1.02] hover:brightness-110"
          style={{ backgroundImage: "url('/Home/employee-culture.jpg')" }}
        >
          <a
            href="/employeeculture"
            className="flex w-[100%] h-[100%] p-[1rem] items-end"
          >
            <h2 className="lg:text-2xl text-[19px] font-bold text-white transition-colors duration-300 hover:text-gray-100">
              Employee Culture
            </h2>
          </a>
        </div>
        <div
          className="working-image bottom-[2rem] mt-[1rem] flex flex-col items-start p-4 h-[15rem] 2xl:h-[15rem] bg-center bg-no-repeat bg-cover rounded-md w-full transition-all duration-300 hover:shadow-lg hover:scale-[1.02] hover:brightness-110"
          style={{ backgroundImage: "url('/Home/employee.jpg')" }}
        >
          <a
            href="/employeebenefits"
            className="flex w-[100%] h-[100%] p-[1rem] items-end"
          >
            <h2 className="lg:text-2xl text-[19px] font-bold text-white transition-colors duration-300 hover:text-gray-100">
              Employee Benefits
            </h2>
          </a>
        </div>
      </div>
    </div>
  );
};

export default WorkWithTcsComponent;
